module.exports = __webpack_public_path__ + "static/media/majorA3.5b484e5.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorA3.wav
// module id = /4sn
// module chunks = 0